/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { Card } from "@material-ui/core";
import { useFormik } from "formik";

import { AlertMessage } from "../../../Components/AlertMessage";
import * as auth from "../_redux/authRedux";
import { SET_INVITED_USER_PASSWORD } from "../mutations/index";

import { useApprovedLinkValidationSchema } from "./useApprovedLinkValidationSchema";

function ApprovedLink(props) {
  const { initialValues, approvedLinkValidationSchema } = useApprovedLinkValidationSchema();

  const [loading, setLoading] = useState(false);

  const [isRedirect, setRedirectLogin] = useState(false);

  const [isid, setId] = useState("");

  const [state, setState] = useState({
    open: false,
    message: "Password successfully created!",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setState({ ...state, open: false });
  };

  const [
    setPassword,
    { loading: pwdLoading, error: pwdError, data: pwdData },
  ] = useMutation(SET_INVITED_USER_PASSWORD);

  useEffect(() => {
    setId(props?.match?.params?.id);
  }, []);

  useEffect(() => {
    if (pwdLoading) {
      setLoading(true);
    }

    if (pwdError) {
      formik.setStatus(pwdError.toString().replace("Error: Error:", ""));
      setLoading(false);
    }

    if (pwdData) {
      setState({ ...state, open: true });
      setRedirectLogin(true);
    }
  }, [pwdLoading, pwdError, pwdData]);

  const getInputClasses = fieldname => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: approvedLinkValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setLoading(true);
      setPassword({
        variables: {
          phoneno: values.phonenumber,
          idToken: isid,
          password: values.password,
        },
      });
      setSubmitting(false);
    },
  });

  return (
    <div className="login-form login-signin" style={{ display: "block" }}>
      <AlertMessage
        message={state.message}
        severity={state.severity}
        handleClose={handleSnackbarClose}
        open={state.open}
      />
      {isRedirect && <Redirect to="/login" />}
      <div className="text-center">
        <h1 style={{ fontWeight: "bold", fontSize: "3rem" }}>
          <FormattedMessage id="AUTH.REGISTER.TITLE" />
        </h1>
      </div>
      <Card className="px-5 py-5">
        <h5 className="text-center">Sign up for your account</h5>
        <div className="d-flex flex-wrap justify-content-center align-items-center">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={
              "btn btn-outline-secondary bg-white font-weight-bold px-2 py-2 mr-5"
            }
          >
            <i className="fab fa-google"></i>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={
              "btn btn-outline-secondary bg-white font-weight-bold px-3 py-2 mr-5"
            }
          >
            <i className="fab fa-apple"></i>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={
              "btn btn-outline-secondary bg-white font-weight-bold px-3 py-2 mr-5"
            }
          >
            <span>
              <i className="fab fa-windows"></i>
            </span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
        <div className="justify-content-center text-center py-1">OR</div>
        <form
          id="kt_login_signin_form"
          className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          onSubmit={formik.handleSubmit}
        >
          {/* Begin: Alert */}
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          {/* End: Alert */}

          {/* Begin: Email */}
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Phone number (Optional)"
              type="email"
              className={`form-control form-control-solid h-auto ${getInputClasses(
                "phonenumber",
              )}`}
              name="phonenumber"
              {...formik.getFieldProps("phonenumber")}
            />
            {formik.touched.phonenumber && formik.errors.phonenumber && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.phonenumber}</div>
              </div>
            )}
          </div>
          {/* End: Email */}

          {/* Begin: Password */}
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Password"
              type="password"
              className={`form-control form-control-solid h-auto ${getInputClasses(
                "password",
              )}`}
              name="password"
              {...formik.getFieldProps("password")}
            />
            {(formik.touched.password && formik.errors.password ) && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            )}
          </div>
          {/* End: Password */}

          {/* Begin: Confirm Password */}
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Confirm Password"
              type="password"
              className={`form-control form-control-solid h-auto ${getInputClasses(
                "changepassword",
              )}`}
              name="changepassword"
              {...formik.getFieldProps("changepassword")}
            />
            {(formik.touched.changepassword && formik.errors.changepassword) && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">
                  {formik.errors.changepassword}
                </div>
              </div>
            )}
          </div>
          {/* End: Confirm Password */}

          {/* Begin: Terms and Conditions */}
          <span>
            By signing up, I accept the equipbid{" "}
            <Link
              to="/terms"
              target="_blank"
              className="mr-1"
              rel="noopener noreferrer"
            >
              Terms of Service
            </Link>
            and acknowledge the{" "}
            <Link
              to="/terms"
              target="_blank"
              className="mr-1"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </span>
          {/* End: Terms and Conditions */}

          <div className="d-flex flex-wrap justify-content-center align-items-center">
            <button
              id="kt_login_signin_submit"
              type="submit"
              disabled={formik.isSubmitting}
              className={
                "btn btn-outline-secondary bg-white w-100 font-weight-bold px-9 py-4"
              }
            >
              <span>
                <FormattedMessage id="AUTH.GENERAL.SIGNUP_BUTTON" />
              </span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
          <hr className="mb-0" />
          <div className="text-center">
            <span>
              Already have an account?{" "}
              <Link
                to="/auth/login"
                className="mr-1 ml-2 text-blue-two"
                rel="noopener noreferrer"
              >
                <span>
                  <FormattedMessage id="AUTH.LOGIN.BUTTON" />
                </span>
              </Link>
            </span>
          </div>
        </form>
      </Card>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ApprovedLink));
